import { render, staticRenderFns } from "./stockreset.vue?vue&type=template&id=d27e597e&scoped=true&"
import script from "./stockreset.vue?vue&type=script&lang=js&"
export * from "./stockreset.vue?vue&type=script&lang=js&"
import style0 from "./stockreset.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stockreset.vue?vue&type=style&index=1&id=d27e597e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e597e",
  null
  
)

export default component.exports